import React from 'react';
import ReactTable from 'react-table';
import Loading from '../components/Loading';
import { tableTextFilterMethod } from '../utils';

const translations = {
  previousText: 'anterior',
  nextText: 'próximo',
  loadingText: <Loading />,
  noDataText: 'nenhum dado encontrado',
  pageText: 'pág.',
  ofText: 'de',
  rowsText: 'registros',
};

const Table = props => (
  <ReactTable
    className="table-default"
    defaultFilterMethod={tableTextFilterMethod}
    {...translations}
    {...props}
  />
);

export default Table;
